export const MAX_PASTA = 100;
export const INITIAL_PASTA_STATE = 0;
export const VISIBLE_PASTA_STATE = 1;
export const REMOVED_PASTA_STATE = 2;

export const WIN_POINT = 100;
export const LOSE_POINT = -50;
